function Dash() {
  return " - ";
}

export default Dash;
